import type { MonitoringOverview } from '../../../services/dmMonitoringOverview';
import { ALWAYS_SHOWN_LEVELS, LEVEL_LEGEND } from './overviewLegend';
import type { HistoryView } from './overviewPeriod';
import type { PieSlice } from './OverviewDonut';
import { NotificationBreakdownCard } from './NotificationBreakdownCard';

const INFO = {
    open: 'Open DM notifications by the level DM gave them',
    range: 'Every notification DM raised in the range, open or resolved, by the level DM gave it'
} as const;

function levelSlices(levels: MonitoringOverview['levels']): PieSlice[] {
    return levels
        .filter((entry) => entry.count > 0 || ALWAYS_SHOWN_LEVELS.includes(entry.level))
        .map((entry) => ({ key: entry.level, count: entry.count, ...LEVEL_LEGEND[entry.level] }));
}

interface LevelsCardProps {
    levels: MonitoringOverview['levels'];
    history: HistoryView;
}

export function LevelsCard({ levels, history }: LevelsCardProps) {
    const raised = history.data?.raised.levels;
    return (
        <NotificationBreakdownCard
            title="Notifications by level"
            info={INFO}
            openSlices={levelSlices(levels)}
            rangeSlices={raised ? levelSlices(raised) : null}
            history={history}
        />
    );
}
